export const parseHashRoute = (hash: string): any => {
  const params = new URLSearchParams(hash.replace("#", ""));
  const result = {};
  params.forEach((value, key) => {
    result[key] = value;
  });
  return result;
};
